export const encodeBase64 = (value: string): string => {
  return window.btoa(value);
};

export const decodeBase64 = (value: string): string => {
  return window.atob(value);
};
